export const formatFirstLetterUpperRestLower = (
    value?: string | null
): string => {
    if (!value) return "N/A";

    const cleaned = value?.replace(/_/g, " ");

    return (
        cleaned?.charAt(0).toUpperCase() +
        cleaned?.slice(1).toLowerCase()
    );
};